// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".agency-logo-search[data-v-79f93273]{z-index:5;left:.25em;bottom:.25em;position:absolute}.agency-logo-search[data-v-79f93273] img{width:auto;height:auto}.agency-logo[data-v-79f93273]{margin:-2em 0 0}.agency-logo img[data-v-79f93273]{height:2em}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
